import { render, staticRenderFns } from "./peligros.vue?vue&type=template&id=1fad22d0&"
import script from "./peligros.vue?vue&type=script&lang=js&"
export * from "./peligros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports